/**
 * Atmospheric background for the reference band: three drifting color blobs.
 * Absolutely positioned inside the `RefSections` wrapper (never `fixed`) so it
 * stays behind the new sections only. Deliberately paints NO grid — the page
 * has a single global hairline grid (the 72px body grid published by HeroGrid);
 * a second grid here would clash with it and produce doubled lines.
 */
export default function RefBackground() {
  return (
    <div
      aria-hidden="true"
      className="pointer-events-none absolute inset-0 -z-10 overflow-hidden"
    >
      {/* drifting color blobs only — no grid */}
      <span className="absolute left-[-8%] top-[-6%] h-[520px] w-[520px] animate-blob-drift-1 rounded-full opacity-50 blur-[70px] [background:radial-gradient(circle,rgba(215,14,98,0.18),transparent_68%)]" />
      <span className="absolute right-[-10%] top-[24%] h-[600px] w-[600px] animate-blob-drift-2 rounded-full opacity-50 blur-[70px] [background:radial-gradient(circle,rgba(109,79,214,0.13),transparent_68%)]" />
      <span className="absolute bottom-[-8%] left-[30%] h-[480px] w-[480px] animate-blob-drift-3 rounded-full opacity-50 blur-[70px] [background:radial-gradient(circle,rgba(47,107,224,0.10),transparent_68%)]" />
    </div>
  );
}
